import { openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        style: _normalizeStyle(_ctx.sizeStyle),
        class: "inline-block rounded-full bg-gradient-to-r from-green-700 to-green-700 flex items-center justify-center"
    }, [
        (_ctx.imageUrl)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.imageUrl,
                alt: ""
            }, null, 8, _hoisted_1))
            : (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: _normalizeClass(["text-white", _ctx.fontSize])
            }, _toDisplayString(_ctx.userInitials), 3))
    ], 4));
}
